var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "finish-picker" }, [
    _c("h3", { staticClass: "heading" }, [_vm._v("Select a colour or finish")]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "finish-groups" },
      _vm._l(_vm.finishGroups, function(finishGroup) {
        return _c(
          "div",
          { key: finishGroup.handle },
          [
            _c("FinishGroup", {
              attrs: {
                "finish-group": finishGroup,
                finishSelectedProp: _vm.finishSelectedProp
              },
              on: { finishSelected: _vm.onFinishSelected }
            })
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "summary-panel" },
      [
        _c("h5", { staticClass: "summary-heading" }, [
          _vm._v(
            "Selected colour or finish: " + _vm._s(_vm.finishSelectedProp.title)
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "summary" }, [
          _c("div", { staticClass: "thumbnail" }, [
            _c("img", {
              staticClass: "finish",
              attrs: {
                src: _vm.finishSelectedProp.thumbnail,
                alt: _vm.finishSelectedProp.title
              }
            })
          ]),
          _vm._v(" "),
          _vm._m(0)
        ]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c("GroupButton", {
          attrs: {
            urlProp: "/colour-range-and-samples",
            labelProp: "Request a colour chart",
            colourProp: "hotpink"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "info" }, [
      _c("p", [
        _vm._v(
          " For help & inspiration on choosing the right colour scheme for your home you can visit our "
        ),
        _c("a", { attrs: { href: "/colours-finishes" } }, [
          _vm._v("Colours & Finishes")
        ]),
        _vm._v(" page.")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "footnote" }, [
      _vm._v(
        "Colours shown are not exact representations. For more information please see our "
      ),
      _c("a", { attrs: { href: "/colours-finishes" } }, [
        _vm._v("colour range page")
      ]),
      _vm._v(".")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }